import { render } from "./ContentsText.vue?vue&type=template&id=0c38c41d&scoped=true"
import script from "./ContentsText.vue?vue&type=script&lang=js"
export * from "./ContentsText.vue?vue&type=script&lang=js"

import "./ContentsText.vue?vue&type=style&index=0&id=0c38c41d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c38c41d"]])

export default __exports__